import * as React from 'react';
import { Flexbox } from '../Flexbox/Flexbox';
import styled from 'styled-components';

export interface Props {
  center?: boolean;
  children: any;
  direction?: string;
  className?: string;
}

export class Grid extends React.Component<Props> {
  render() {
    const { center, children } = this.props;

    return (
      <GridComponent
        className={this.props.className}
        showAfter={true}
        style={{
          justifyContent: center ? 'center' : '',
          flexFlow: this.props.direction ? this.props.direction : 'row wrap',
        }}
      >
        {children}
      </GridComponent>
    );
  }
}

const GridComponent: any = styled(Flexbox)`
  justify-content: flex-start;

  ${(props: any) => {
    if (props.showAfter === true) {
      return `
        &:after {
          content: "";
          flex: auto;
        }
      `;
    }

    return ``;
  }};
`;
